<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectLayout-1">
<div id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" src="image/wtwtitle.jpg"/>
</div>
</div>
<div class="Basic-Text-Frame" id="_idContainer002">
<p class="Basic-Paragraph ParaOverride-1"><span class="CharOverride-1">Sarah Marie A. Jette</span></p>
<div class="_idGenObjectLayout-1">
<div id="_idContainer001">
<img alt="" class="_idGenObjectAttribute-1" src="image/ISLANDPRT_Horiz_BLKlogo.png"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// what_wind_can_tell_you_interior_12_pt.vue?a9f0e47e